import { useQueries } from '@tanstack/react-query'
import { useMemo, useState } from 'react'

import { type CardIdType } from '@/defs/card'
import { getCardQuery } from '@/utils/cardUtil'

type Props = {
  cardId?: CardIdType
  enabled?: boolean
}

export const useCard = ({ cardId: cardIdProp, enabled = true }: Props) => {
  const [wasEverEnabled, setWasEverEnabled] = useState(enabled)
  if (enabled && !wasEverEnabled) setWasEverEnabled(true)

  const cardId = wasEverEnabled && cardIdProp ? cardIdProp : false
  const queries = useMemo(() => (cardId ? [getCardQuery(cardId)] : []), [cardId])
  const [result] = useQueries({ queries })

  return { card: result?.data ? result.data : undefined, hasError: !!result?.isError, loading: !!result?.isLoading }
}
